const filterChildren = (filteredValues, child) => {
  const valueIndex = filteredValues.findIndex(v => v === child.id);

  if (valueIndex !== -1) {
    filteredValues.splice(valueIndex, 1);
  }

  if (child.children)
    return child.children.reduce(filterChildren, filteredValues);

  return filteredValues;
};

const flattenTree = (values, parents, children, autoSelectChildren = true) => {
  const reducedParents = parents.reduce((filteredValues, parent) => {
    if (!parent.children) return filteredValues;

    const childIds = parent.children.map(child => child.id);
    const checked = childIds.map(id => filteredValues.includes(id));

    if (autoSelectChildren && checked.includes(false) === false) {
      filteredValues.push(parent.id);
      return filteredValues.filter(value => !childIds.includes(value));
    }

    if (filteredValues.includes(parent.id)) {
      return filteredValues.filter(value => value !== parent.id);
    }

    return filteredValues;
  }, values);

  const reducedChildren = children.reduce(filterChildren, reducedParents);

  return reducedChildren;
};

const uniqueValues = values =>
  values.filter((value, index) => values.indexOf(value) === index);

export default (query, action) => {
  const { checked, value, id, parents, children, autoSelectChildren } = action;
  const values = query[id] || [];

  if (checked) {
    values.push(value);

    return {
      ...query,
      [id]: uniqueValues(
        flattenTree(values, parents || [], children || [], autoSelectChildren)
      ),
    };
  }

  // Filter out all children from array
  const childrenIds = children ? children.map(child => child.id) : [];
  const parentIds = parents ? parents.map(p => p.id) : [];
  const filtered = values
    .filter(x => x !== value)
    .filter(x => !childrenIds.includes(x));

  if (filtered.length === 0) {
    delete query[id]; // eslint-disable-line
    return {
      ...query,
    };
  }

  // Need to traverse parent to set new values
  if (filtered.length === values.length) {
    return {
      ...query,
      [id]: uniqueValues(
        filtered
          .concat(
            parents.reduce(
              (results, curr) => {
                if (results.done) {
                  return results;
                }

                curr.children.forEach(child => {
                  if (child.id === value) {
                    return;
                  }

                  results.values.push(child.id);
                });

                // Abort reduce when to level selected has been reached
                if (values.includes(curr.id)) {
                  results.done = true; // eslint-disable-line
                }

                return results;
              },
              {
                done: false,
                values: [],
              }
            ).values
          )
          // Filter out all parents from array
          .filter(value => !parentIds.includes(value))), // eslint-disable-line
    };
  }

  return {
    ...query,
    [id]: uniqueValues(filtered.filter(x => !parentIds.includes(x))),
  };
};
